import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcoClose = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 47,
	height: 47,
	fill: "#9095B5",
	viewBox: "0 0 3.64 3.64",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M0.25 3.6c-0.06,0.05 -0.15,0.05 -0.21,0 -0.05,-0.06 -0.05,-0.15 0,-0.21l1.58 -1.57 -1.58 -1.58c-0.05,-0.05 -0.05,-0.14 0,-0.2 0.06,-0.05 0.15,-0.05 0.21,0l1.57 1.58 1.57 -1.58c0.06,-0.05 0.15,-0.05 0.21,0 0.05,0.06 0.05,0.15 -0.01,0.2l-1.57 1.58 1.58 1.57c0.05,0.06 0.05,0.15 0,0.21 -0.06,0.05 -0.15,0.05 -0.21,0l-1.57 -1.58 -1.57 1.58z" })
});
export default SvgIcoClose;
